import React from 'react';
import TooltipComponent from '../Tooltip/TooltipComponent';
import styles from './ButtonGroup.module.scss';

interface Button {
  id: string;
  disabled?: boolean;
  value?: string;
  checked: boolean;
  label: string;
  disabledMsg?: string;
}

interface ButtonGroupProps {
  id: string;
  onClickAction?: (left: boolean, id: string) => any;
  leftButton: Button;
  rightButton: Button;
}

const ButtonGroup: React.FC<ButtonGroupProps> = (props) => {
  const { id, leftButton, rightButton, onClickAction = () => { } } = props;

  const leftBtn = (
    <label htmlFor={leftButton.id}>
      <input
        type="radio"
        disabled={leftButton?.disabled || false}
        value={leftButton?.value || leftButton?.id}
        id={leftButton?.id}
        checked={leftButton.checked}
        onClick={() => onClickAction(true, leftButton?.id)}
        onChange={() => { }}
      /><span>{leftButton.label}</span>
    </label>
  );

  const rightBtn = (
    <label htmlFor={rightButton?.id}>
      <input
        type="radio"
        disabled={rightButton?.disabled || false}
        value={rightButton?.value || rightButton?.id}
        id={rightButton?.id}
        checked={rightButton.checked || !leftButton.checked}
        onClick={() => onClickAction(false, rightButton?.id)}
        onChange={() => { }}
      /><span>{rightButton.label}</span>
    </label>
  );

  return (
    <div data-testid={id} className={styles.ButtonGroup}>
      {leftButton.disabled && leftButton.disabledMsg
        ? <TooltipComponent title={leftButton.disabledMsg}>{leftBtn}</TooltipComponent>
        : leftBtn}
      {rightButton.disabled && rightButton.disabledMsg
        ? <TooltipComponent title={rightButton.disabledMsg}>{rightBtn}</TooltipComponent>
        : rightBtn}
    </div>
  );
};

export default ButtonGroup;
